import { BreadcrumbDesignTokens } from '@primeuix/themes/types/breadcrumb';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const breadcrumsOverride: BreadcrumbDesignTokens = {
  root: {
    background: getColor('SkyBlue90'),
    padding: `${getRem(12)} ${0} ${getRem(0)} ${0}`,
    gap: getRem(8),
  },
  separator: {
    color: getColor('Sandstone40'),
  },
  item: {
    color: getColor('Sandstone30'),
  },
};
